module.exports = __webpack_public_path__ + "static/media/result_fh_ja.6809d1eb.jpg";